import React from "react";
import { Rnd } from "react-rnd";
// import plcHolderImg from "assets/modal/signplaceholder.png";
import { ReactComponent as CancelIcon } from "assets/cancel.svg"

const PlaceHolderRnd = ({ item, index, setPlaceHolders, placeholders }) => {


  const onDrapStop = (node, d) => {
    let itemWidth = parseInt(item.width, 10);
    item.x = d.x > 770 ? 870 - itemWidth : d.x < 0 ? 0 : d.x;
    item.y = d.y < 0 ? 0 : d.y;
    setPlaceHolders([...placeholders]);
  };

  const onResizeStop = (ref, pos) => {
    item.height = ref.offsetHeight;
    item.width = ref.offsetWidth;
    item.x = pos.x;
    item.y = pos.y;
    setPlaceHolders([...placeholders]);
  };

  const onDelete = (e) => {
    e.stopPropagation();
    const newPlC = placeholders.filter((_, i) => i !== index);
    setPlaceHolders(newPlC);
  };

  return (
    <>
      <Rnd
        size={{ width: item?.width, height: item?.height }}
        position={{ x: item?.x, y: item?.y }}
        // onDragStart={(node) => onDragStart(node)}
        onDragStop={(node, e, d) => onDrapStop(node, e, d)}
        onResizeStop={(e, direction, ref, delta, position) =>
          onResizeStop(ref, position)
        }
        id={item.id}
        className="btn"
      >
        <div
          id="remove-overly-div"
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
          }}
        >
          <div style={{ position: "relative" }}>
            <button
              onClick={onDelete}
              style={{
                backgroundColor: "transparent",
                padding: "6px",
                border: "none",
                borderRadius: "none",
                position: "absolute",
                zIndex: "1",
                right: "-4px",
                top: "-4px",
              }}
            >
              <CancelIcon height={16} width={16} />
            </button>
          </div>
        </div>
        <img
          className="notsign"
          alt="placeholderimg"
          style={{ display: "none", width: "100%", cursor: "pointer", height: "100%" }}
          src="/signplaceholder.png"
        />
      </Rnd >
    </>
  );
};

export default PlaceHolderRnd;
